import { render, staticRenderFns } from "./index.vue?vue&type=template&id=33c15aec&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33c15aec')) {
      api.createRecord('33c15aec', component.options)
    } else {
      api.reload('33c15aec', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=33c15aec&lang=pug", function () {
      api.rerender('33c15aec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dojo/evaluations/addEvaluation/scoreDescription/index.vue"
export default component.exports